module.exports = __webpack_public_path__ + "static/img/logo.a64a9f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/common/logo.png
// module id = 8f4c
// module chunks = 7